import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Box,
  Typography,
  IconButton,
  Avatar,
  Checkbox,
  SxProps,
  Theme,
  SelectChangeEvent,
  Tooltip,
  List,
  ListItem,
  Card,
  CardContent,
} from "@mui/material";
import moment from "moment";
import CustomButton from "../../common/CustomButton/CustomButton";
import clockIcon from "../../assets/svgs/clock-icon.svg";
import menuIcon from "../../assets/svgs/menu-icon.svg";
import { TablesStyles } from "./TablesStyles";
import highIcon from "../../assets/svgs/high.svg";
import mediumIcon from "../../assets/svgs/medium.svg";
import lowIcon from "../../assets/svgs/low.svg";
import infoIcon from "../../assets/svgs/info-icon.svg";
import renewalIcon from "../../assets/svgs/renewal-icon.svg";
import cancelIcon from "../../assets/svgs/cancelled-icon.svg";
import overdueIcon from "../../assets/svgs/overdue-icon.svg";
import activeIcon from "../../assets/svgs/active-icon.svg";
import pendingIcon from "../../assets/svgs/pending-icon.svg";
import sortIcon from "../../assets/svgs/sorting-icon.svg";
import docIcon from "../../assets/svgs/document-icon.svg";
import downloadIcon from "../../assets/svgs/download-icon.svg";
import descendingSort from "../../assets/svgs/decending-sort.svg";
import inProgress from "../../assets/svgs/in-progress.svg";
import phoneIcon from "../../assets/svgs/phone-icon.svg";
import mailIcon from "../../assets/svgs/mail-icon.svg";
import {
  ACTIVE,
  CLAIMS,
  CLAIM_STATUS,
  CLOSED,
  CONTACT_DETAILS,
  CUSTOMER_DETAILS,
  CUSTOMER_POLICY_STATUS,
  EXPIRED,
  HIGH_PRIORITY,
  INFO_ICON,
  LOW_PRIORITY,
  MEDIUM_PRIORITY,
  MENU_ICON,
  NO_DATA_AVAILABLE,
  OVERDUE,
  OVERDUE_CAPS,
  OPEN,
  PENDING_RENEWAL,
  POLICY_DETAILS,
  POLICY_STATUS,
  POLICY_TYPE,
  RENEWAL,
  ACTIVE_CAPS,
  DUE_RENEWAL,
  CANCELLED,
  CANCELLED_CAPS,
  CUSTOMER_STATUS,
  SORT_ICON,
  DETAILS,
  DOWNLOAD,
  PAY_NOW,
  COMMISSION_STATUS,
  TASKS,
  TASK,
  PENDING,
  ACTIVE_LOWER,
  POLICY_LOWER,
  STATUS_LOWER,
  CLIENT_NAME_LOWER,
  PRIORITY_LOWER,
  TASK_DATE_LOWER,
  TASK_LOWER,
  COMMISSION_POLICY_DETAILS,
  COMMISSION_CUSTOMER_DETAILS,
  FOLDER_NAME,
  FILE_NAME,
  NOTES,
  ARCHIVE_FILE,
  ARE_YOU_SURE_ARCHIVE,
  FILE_LOWER,
  CANCEL,
  FOLDER_LOWER,
  ARCHIVING_THE_FOLDER,
  ADD_TASK,
  CLIENT_DETAILS_LOWER,
  RENEWALED,
  RENEWAL_IN_PROGRESS,
  NO_POLICIES_AVAILABLE,
} from "../../constants";
import CustomTooltip, {
  StyledListItemText,
} from "../../common/Tooltip/Tooltip";

import ImageAndText from "../ImageAndText/ImageAndText";
import paynowIcon from "../../assets/svgs/paynow-icon.svg";
import stringAvatar from "../../utils/StringAvatar";
import { useNavigate } from "react-router-dom";
import { myTasksTooltip } from "../../constants/TootipData";
import { personData } from "../../constants/myTasksPersonData";
import { personChat } from "../../constants/myTasksPersonChatData";
import Drawers from "../Drawers/Drawers";
import Notes from "../Notes/Notes";
import CustomIcon from "../../common/CustomIcon/CustomIcon";
import styled from "@emotion/styled";
import ModalComponent from "../../common/ModalComponent/ModalComponent";
import reScheduleIcon from "../../assets/svgs/re-schedule.svg";
import { customerDetailsOverviewOptions } from "../../constants/CustomerDetailsOverviewOptions";
import SendRemainder from "../SendRemainder/SendRemainder";
import { sendRemaindersAndShareMarketData } from "../../constants/SendRemaindersAndShareMarketData";
import { getCookie } from "../../utils/Utility";
import AddTaskForm from "../AddTaskForm/AddTaskForm";
import { IPostAddTaskResponseData } from "../../models/agent/Tasks/addTask";
import { useAppDispatch } from "../../store/hooks";
import { EditAddTask } from "../AddTaskForm/AddTaskActions";
import EmptyScreen from "../EmptyScreen/EmptyScreen";
import { IAgentTask } from "../../models/agent/policiesListing";
import { PostCustomerDetails } from "../CustomerDetailsList/CustomerDetailsListActions";
interface DataTableProps {
  data: Array<Record<string, any>>;
  headerData: string[];
  type?:
    | "default"
    | "primary"
    | "secondary"
    | "customerPolicies"
    | "customerListing"
    | "myTasksTable"
    | "overviewTable"
    | "invoicesTable"
    | "commissionStatements"
    | "nohover"
    | "documentListingList"
    | "policyListing";
  onhandleDateClick?: () => void;
  primary?: boolean;
  additionaltableContainer?: SxProps<Theme>;
  selectedKey?: string;
  setOpenTaskDialog?: Dispatch<SetStateAction<boolean>>;
  setModalData?: Dispatch<SetStateAction<IAgentTask | null>>;
  isEditTask?: boolean;
}
const StyledCustomerDetailsAvatar = styled(Box)({
  "& .MuiAvatar-root": {
    width: "32px",
    height: "32px",
    border: "1px solid var(--primary-grey)",
  },
});
const StyledCheckbox = styled(Checkbox)({
  color: "var(--black)",
  padding: "0px",
  width: "16px",
  "& .MuiSvgIcon-root": {
    fontSize: "17px",
  },
});
const isOverdue = (dateTime: string): boolean => {
  const taskDate = moment(dateTime, "DD MMM YYYY,hh:mm a");
  const today = moment().startOf("day");

  return taskDate.isBefore(today);
};

const Tables: React.FC<DataTableProps> = ({
  data,
  headerData,
  type = "default",
  onhandleDateClick,
  primary = false,
  additionaltableContainer,
  selectedKey,
  setOpenTaskDialog,
  setModalData,
  isEditTask,
}) => {
  const ShowingData = (key: string | undefined) => {
    const today = new Date();
    if (key === "0") {
      return data;
    } else if (key === "1") {
      return data.filter((item) => item.status === "Open");
    } else if (key === "2") {
      return data.filter((item) => item.status === "Completed");
    } else if (key === "3") {
      return data.filter((item) => new Date(item.dueDate) < today);
    }
    return data;
  };

  const displayData: Array<Record<string, any>> = ShowingData(selectedKey);

  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setIsFormOpen(false);
  };
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [hoveredRow, setHoveredRow] = useState<number | null>(null);
  const [checkedItems, setCheckedItems] = useState<number[]>([]);
  const [openTooltipRow, setOpenTooltipRow] = useState<number | null>(null);
  const [toolTipIndex, setToolTipIndex] = useState<number | null>(null);
  const [toolTipRowData, setToolTipRowData] = useState<
    IPostAddTaskResponseData | {}
  >({});
  const [notesOpen, setNotesOpen] = useState(false);
  const [sortOrder, setSortOrder] = useState<Record<number, boolean>>({});
  const [modalOpen, setModalOpen] = useState(false);
  const [fileName, setFileName] = useState("");
  const [isFolder, setIsFolder] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedDropdownValue, setSelectedDropdownValue] = useState("");
  const [tasksOpen, setTasksOpen] = useState(false);
  const [activeTooltip, setActiveTooltip] = useState<number | null>(null);
  const [TaskName, setTaskName] = useState("");

  useEffect(() => {
    // setOpenTooltipRow(null);
    setToolTipIndex(null);
  }, [hoveredRow, notesOpen, modalOpen, tasksOpen, activeTooltip]);
  useEffect(() => {
    if (openTooltipRow !== null) {
      const rowData = displayData?.[openTooltipRow];

      setToolTipRowData(rowData);

      const nameToSet = rowData.fileName || rowData.folderName;
      setIsFolder(!!rowData.folderName);
      setFileName(nameToSet);
    }
  }, [openTooltipRow]);

  const handleDetailsToolTipOpen = (index: number | null) => {
    setActiveTooltip((prevIndex) => (prevIndex === index ? null : index));
  };

  const handleDetailsToolTipClose = () => {
    setActiveTooltip(null);
  };
  if (!displayData || displayData.length === 0) {
    if (type === "myTasksTable") {
      return (
        <>
          <EmptyScreen />
        </>
      );
    }
    return (
      <Card sx={TablesStyles.noPoliciesAvailable}>
        <CardContent>
          <Typography variant="h6">{NO_POLICIES_AVAILABLE}</Typography>
        </CardContent>
      </Card>
    );
  }
  const drawerOptions = [
    { value: "View", key: "view" },
    { value: "Edit", key: "edit" },
    { value: "Move", key: "move" },
    { value: "Archive", key: "archive" },
  ];
  const handleRowClick = (
    type: String,
    customerDetails: { customerId: string; customerName: string },
    rowData?: any
  ) => {
    if (type === "policyListing") {
      navigate("/agent/policyDetails");
    }
    if (type === "overviewTable") {
      navigate(
        `/agent/policyDetails/${rowData.policyId}/${rowData.carrier}/${rowData.system}/${rowData.lobCode}/${rowData.customerId}`
      );
    }
    if (type === "customerListing") {
      if (rowData.customerId && rowData.system && rowData.carrier) {
        const requestBody = {
          customerId: rowData.customerId,
          system: rowData.system,
          carrier: rowData.carrier,
        };
        dispatch(PostCustomerDetails(requestBody));
      }
      navigate(`/agent/customerDetails/${customerDetails.customerId}`);
    }
    if (type === "myTasksTable") {
      if (setOpenTaskDialog && setModalData) {
        setOpenTaskDialog(true);
        setModalData(rowData);
      }
    }
  };

  const headers = headerData?.length === 0 ? displayData[0] : headerData;
  const renderCellContent = (key: string, value: any, rowIndex: any) => {
    switch (key) {
      case "address":
        if (typeof value === "object" && value !== null) {
          const {
            addr1,
            addrTypeCd,
            city,
            county,
            stateProvCd,
            postalCode,
            regionCd,
            regionISOCd,
          } = value;
          return (
            <Box sx={TablesStyles.policyDetails}>
              <Typography>
                {addr1}, {city}
              </Typography>
              <Typography>
                {county}, {stateProvCd} {postalCode} {regionISOCd} {regionCd}
              </Typography>
            </Box>
          );
        }
        return "----";
      case TASK_DATE_LOWER:
        const isOverdues = isOverdue(value);

        return (
          <>
            {/* <CustomButton
              onClick={onhandleDateClick}
              additionalContainerClassName={TablesStyles.dateButtonContainer}
              additionalClassName={
                isOverdues
                  ? TablesStyles.dateoverdueButton
                  : TablesStyles.dateButton
              }
              text={value}
              type="grey-outlined"
            /> */}
            <Typography sx={TablesStyles.taskDate}>{value}</Typography>
          </>
        );
      case PRIORITY_LOWER:
        let priorityText = "";
        let priorityImg = null;

        if (value?.toLowerCase() === "high" || value === "unknown") {
          priorityText = HIGH_PRIORITY;
          priorityImg = highIcon;
        } else if (value?.toLowerCase() === "medium") {
          priorityText = MEDIUM_PRIORITY;
          priorityImg = mediumIcon;
        } else if (value?.toLowerCase() === "low") {
          priorityText = LOW_PRIORITY;
          priorityImg = lowIcon;
        }

        return (
          <Box sx={TablesStyles.priorityContainer}>
            {priorityImg && <img src={priorityImg} alt={priorityText} />}
            <Typography sx={TablesStyles.priorityText}>
              {priorityText}
            </Typography>
          </Box>
        );
      case "customerName":
        return (
          <Box sx={TablesStyles.clientInfoContainer}>
            <Typography sx={TablesStyles.clientName}>{value}</Typography>
            {/* <Tooltip
              arrow
              placement="right"
              open={activeTooltip === rowIndex}
              onClose={handleDetailsToolTipClose}
              componentsProps={{
                tooltip: {
                  sx: {
                    background: "var( --white)",
                    border: "1px solid #CFD4E1",
                    color: "var( --black)",
                  },
                },
                arrow: {
                  sx: {
                    color: "var( --white)",
                    position: "relative",
                    "&::before": {
                      border: "1px solid #CFD4E1",
                      margin: "-1px",
                    },
                  },
                },
              }}
              title={
                <List>
                  <ListItem button>
                    <StyledListItemText>
                      <ImageAndText image={mailIcon} text={value.clientEmail} />
                    </StyledListItemText>
                  </ListItem>
                  <ListItem button>
                    <StyledListItemText>
                      <ImageAndText
                        image={phoneIcon}
                        text={value.clientPhone}
                      />
                    </StyledListItemText>
                  </ListItem>
                </List>
              }
            >
              <IconButton onClick={() => handleDetailsToolTipOpen(rowIndex)}>
                <img src={infoIcon} alt={INFO_ICON} />
              </IconButton>
            </Tooltip> */}
          </Box>
        );
      case POLICY_LOWER:
        return (
          <Typography
            sx={TablesStyles.policyText}
            onClick={() => navigate("/agent/policyDetails")}
          >
            {value}
          </Typography>
        );
      case STATUS_LOWER: //Message for status
        const renderStatus = (status: string) => {
          let statusImage = "";
          let statusText = "";
          if (status?.toLowerCase() === "open") {
            // statusImage = clockIcon;
            statusText = "Open";
          }
          if (status?.toLowerCase() === "completed") {
            // statusImage = activeIcon;
            statusText = "Completed";
          }
          if (status?.toLowerCase() === "in progress") {
            statusImage = inProgress;
            statusText = "In Progress";
          }
          if (status?.toLowerCase() === "rescheduled") {
            statusImage = reScheduleIcon;
            statusText = "Rescheduled";
          }
          return (
            <Box>
              {statusText}
              {/* <ImageAndText
              additionalClassName={TablesStyles.statusContainer}
              image={}
              text={statusText} 
              
            /> */}
            </Box>
          );
        };
        return renderStatus(value);
      case CUSTOMER_STATUS:
        let customerStatusImg = "";
        let customerStatusText = "";
        if (value?.toLowerCase() === ACTIVE_LOWER) {
          customerStatusImg = activeIcon;
          customerStatusText = ACTIVE_CAPS;
        } else if (value?.toLowerCase() === RENEWAL) {
          customerStatusImg = renewalIcon;
          customerStatusText = DUE_RENEWAL;
        } else if (value?.toLowerCase() === OVERDUE) {
          customerStatusImg = overdueIcon;
          customerStatusText = OVERDUE_CAPS;
        } else if (value?.toLowerCase() === CANCELLED) {
          customerStatusImg = cancelIcon;
          customerStatusText = CANCELLED_CAPS;
        }

        return (
          <ImageAndText
            imageClassName={TablesStyles.customerStatusImg}
            additionalClassName={TablesStyles.customerStatusContainer}
            image={customerStatusImg}
            text={customerStatusText}
          />
        );
      case "policyNumber":
        const dataobject = displayData[rowIndex];
        const policyid = dataobject.policyId;
        const carrier = dataobject.carrier;
        const system = dataobject.system;
        const lobCode = dataobject.lobCode;

        return (
          <Box sx={TablesStyles.policyDetails}>
            {policyid ? (
              <Typography
                sx={TablesStyles.additionalPolicyNumber}
                // onClick={() =>
                //   navigate(
                //     `/agent/policyDetails/${policyid}/${carrier}/${system}/${lobCode}/2001`
                //   )
                // }
              >
                {value || "N/A"}
              </Typography>
            ) : (
              <Tooltip
                title={`No Policy Found with Policy No. ${value}`}
                arrow
                placement="top"
                componentsProps={{
                  tooltip: {
                    sx: {
                      bgcolor: "var(--white)",
                      color: "var(--black)",
                      border: "1px solid var(--black)",
                      fontSize: "12px",
                      padding: "8px 12px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    },
                  },
                  arrow: {
                    sx: {
                      color: "var(--white)",
                      "&::before": {
                        border: "1px solid var(--black)",
                        margin: "-1px",
                      },
                    },
                  },
                }}
              >
                <Typography sx={TablesStyles.policyNumber}>
                  {value || "N/A"}
                </Typography>
              </Tooltip>
            )}
          </Box>
        );

      case "policyDetails":
        return (
          <Box sx={TablesStyles.policyDetails}>
            <Typography
              onClick={() => navigate("/agent/policyDetails")}
              sx={TablesStyles.policyNumber}
            >
              {value?.policyNumber}
            </Typography>
            <Typography sx={TablesStyles.policyTypeNumber}>
              {value.policyTypeNumber}
            </Typography>
          </Box>
        );

      case POLICY_STATUS:
        let policyStatus = "";
        let policyStatusImg = null;

        if (value?.toLowerCase() === "pending") {
          policyStatus = PENDING_RENEWAL;
          policyStatusImg = pendingIcon;
        } else if (value?.toLowerCase() === "active") {
          policyStatus = ACTIVE;
          policyStatusImg = activeIcon;
        } else if (value?.toLowerCase() === "cancelled") {
          policyStatus = CANCELLED_CAPS;
          policyStatusImg = cancelIcon;
        } else if (value?.toLowerCase() === "renewed") {
          policyStatus = RENEWALED;
          policyStatusImg = renewalIcon;
        } else if (value?.toLowerCase() === "future") {
          policyStatus = RENEWAL_IN_PROGRESS;
          policyStatusImg = renewalIcon;
        }

        return (
          <ImageAndText
            imageClassName={TablesStyles.policyStatusImg}
            image={policyStatusImg}
            text={policyStatus}
            type={type}
          />
        );
      case POLICY_TYPE:
        let policyTypeImage = "";
        if (
          ["house", "homeowners", "property", "dwelling"].includes(
            value?.toLowerCase()
          )
        ) {
          policyTypeImage = "House";
        } else if (["auto", "personalauto"].includes(value?.toLowerCase())) {
          policyTypeImage = "Auto";
        } else if (["personalumbrella"].includes(value?.toLowerCase())) {
          policyTypeImage = "Umbrella";
        }
        return (
          <Box sx={TablesStyles.policyType}>
            {policyTypeImage && <CustomIcon iconName={policyTypeImage} />}
          </Box>
        );
      case CUSTOMER_DETAILS:
        return (
          <Box sx={TablesStyles.customerDetailsContainer}>
            <StyledCustomerDetailsAvatar>
              {value.image.length === 0 ? (
                <Avatar {...stringAvatar(value.customerName)} />
              ) : (
                <Avatar src={value.image} />
              )}
            </StyledCustomerDetailsAvatar>
            <Box>
              <Typography sx={TablesStyles.customerName}>
                {value.customerName}
              </Typography>
              <Typography sx={TablesStyles.customerNumber}>
                {value.customerNumber}
              </Typography>
            </Box>
          </Box>
        );
      case CONTACT_DETAILS:
        return (
          <Box sx={TablesStyles.contactDetailsContainer}>
            <Typography sx={TablesStyles.customerPhoneNumber}>
              {value.customerPhoneNumber}
            </Typography>
            <Typography sx={TablesStyles.customerEmail}>
              {value.customerEmail}
            </Typography>
          </Box>
        );
      case CUSTOMER_POLICY_STATUS: {
        const { active, pending, expired, tasks } = value;
        let statusMessage = "";
        let tasksMessage = "";
        if (active > 0) {
          statusMessage = `${active} ${ACTIVE}`;
          if (pending > 0) {
            statusMessage += ` | ${pending} ${PENDING_RENEWAL}`;
          }
          if (expired > 0) {
            statusMessage += ` | ${expired} ${EXPIRED}`;
          }
        } else if (pending > 0) {
          statusMessage = `${pending}  ${PENDING_RENEWAL}`;
          if (expired > 0) {
            statusMessage += ` | ${expired} ${EXPIRED}`;
          }
        } else if (expired > 0) {
          statusMessage = `${expired} ${EXPIRED}`;
        }
        if (tasks > 0) {
          tasksMessage = `${tasks} ${tasks > 1 ? TASKS : TASK} ${PENDING}`;
        }

        return (
          <Box sx={TablesStyles.tasksMessage}>
            <Typography sx={TablesStyles.statusText}>
              {statusMessage}
            </Typography>
            <Typography sx={TablesStyles.statusText}>{tasksMessage}</Typography>
          </Box>
        );
      }
      case CLAIM_STATUS: {
        const { open = 0, closed = 0 } = value;
        let statusMessage = "";

        if (open === 0 && closed === 0) {
          statusMessage = `0 ${CLAIMS}`;
        } else {
          if (open > 0 && closed > 0) {
            statusMessage = `${open} ${OPEN} | ${closed} ${CLOSED}`;
          } else if (open > 0 && closed === 0) {
            statusMessage = `${open} ${OPEN}`;
          } else if (open === 0 && closed > 0) {
            statusMessage = `${closed} ${CLOSED}`;
          } else if (open === 0 && closed === 0) {
            statusMessage = `0 ${CLAIMS}`;
          }
        }

        return (
          <Typography sx={TablesStyles.statusText}>{statusMessage}</Typography>
        );
      }
      case COMMISSION_STATUS:
        let commissionStatusImage = "";
        let commissionStatusText = "";
        if (value?.toLowerCase() === "pending") {
          commissionStatusImage = clockIcon;
          commissionStatusText = "Pending";
        } else if (value?.toLowerCase() === "paid") {
          commissionStatusImage = activeIcon;
          commissionStatusText = "Paid";
        } else {
        }
        return (
          <ImageAndText
            additionalClassName={TablesStyles.commissionStatusContainer}
            imageClassName={TablesStyles.commissionStatusImage}
            image={commissionStatusImage}
            text={commissionStatusText}
          />
        );
      case TASK_LOWER:
        return <Typography sx={TablesStyles.tasksText}>{value}</Typography>;
      case COMMISSION_POLICY_DETAILS:
        return (
          <Typography sx={TablesStyles.policyDetailsText}>{value}</Typography>
        );
      case COMMISSION_CUSTOMER_DETAILS:
        return (
          <Typography sx={TablesStyles.customerDetailsText}>{value}</Typography>
        );
      case FOLDER_NAME:
        return (
          <ImageAndText
            imageClassName={TablesStyles.folderImage}
            image={<CustomIcon width="24px" height="24px" iconName="Folder" />}
            text={value}
            additionalClassText={TablesStyles.folderName}
          />
        );
      case FILE_NAME:
        return (
          <ImageAndText
            imageClassName={TablesStyles.folderImage}
            image={
              <CustomIcon width="24px" height="24px" iconName="Document" />
            }
            text={value}
            additionalClassText={TablesStyles.folderName}
          />
        );
      case "description": {
        const maxHeight = 50;
        const descriptionStyle = {
          maxHeight: `${maxHeight}px`,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
        };

        return (
          <Box>
            <Typography sx={descriptionStyle}>
              {value.substring(0, 200) || "N/A"}
            </Typography>
          </Box>
        );
      }
      default:
        return value?.length === 0 ? "----" : value;
    }
  };
  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  const handleSelectAllChange = () => {
    if (checkedItems.length === displayData.length) {
      setCheckedItems([]);
    } else {
      setCheckedItems(displayData.map((_: any, index: any) => index));
    }
  };

  const handleCheckboxChange = (index: number) => {
    setCheckedItems((prevCheckedItems) => {
      if (prevCheckedItems.includes(index)) {
        return prevCheckedItems.filter((i) => i !== index);
      } else {
        return [...prevCheckedItems, index];
      }
    });
  };
  let statusData;
  const handlemarkComplete = () => {
    handleTasksClick();
    if (openTooltipRow || openTooltipRow === 0) {
      statusData = displayData[openTooltipRow];

      const requestBody = {
        id: statusData.id,
        taskName: statusData.taskName,
        customerName: statusData.customerName,
        policyNumber: statusData.policyNumber,
        description: statusData.description,
        dueDate: statusData.dueDate,
        dueTime: statusData.dueTime,
        providerId: statusData.providerId,
        priority: statusData.priority,
        status: statusData.status === "Open" ? "Completed" : "Open",
      };
      dispatch(EditAddTask(requestBody));
    }
  };
  const handleToolTip = (index: any) => {
    setOpenTooltipRow(index);
  };

  const handleToolTipItem = (key: string) => {
    if (key === "notes") {
      setNotesOpen(true);
      setOpenTooltipRow(null);
      setToolTipIndex(null);
    }
    if (key === "archive") {
      setModalOpen(true);
      setOpenTooltipRow(null);
      setToolTipIndex(null);
    }
    if (key === "rescheduleTask") {
      setTasksOpen(true);
      setIsFormOpen(true);
      handleTasksClick();
      setOpenTooltipRow(null);
      setToolTipIndex(null);
      setTaskName("Reschedule Task");
    }
    if (key === "editTask") {
      setTasksOpen(true);
      setIsFormOpen(true);
      handleTasksClick();
      setOpenTooltipRow(null);
      setToolTipIndex(null);
      setTaskName("Edit Task");
    }

    if (key === "markComplete") {
      handlemarkComplete();
      setOpenTooltipRow(null);
      setToolTipIndex(null);
    }
    if (key === "markOpen") {
      handlemarkComplete();
      setOpenTooltipRow(null);
      setToolTipIndex(null);
    }

    if (key === "sendRemainder") {
      setDrawerOpen(true);
    }
    if (key === "viewPolicyDetails" || key === "viewDetails") {
      navigate("/agent/policyDetails");
    }
    if (key === "view") {
      if (!isFolder) {
        navigate("/agent/documentDetails");
      }
    }
  };
  const handleNotesClick = () => {
    setNotesOpen(!notesOpen);
  };
  const handleModalClose = () => {
    setModalOpen(!modalOpen);
  };
  const handleSort = (index: number) => {
    setSortOrder((prevSortOrder) => ({
      ...prevSortOrder,
      [index]: !prevSortOrder[index],
    }));
  };
  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };
  const handleRemainderChange = (event: SelectChangeEvent) => {
    setSelectedDropdownValue(event.target.value as string);
  };
  const handleTasksClick = () => {
    setTasksOpen(!tasksOpen);
  };

  return (
    <>
      <TableContainer
        id="tables_container"
        data-test-id="test-tables_container"
        aria-label="Data table container"
        sx={Object.assign(
          {},
          TablesStyles.tableContainer,
          additionaltableContainer
        )}
        component={Paper}
      >
        <Table>
          <TableHead sx={TablesStyles.tableHead}>
            <TableRow>
              {primary && (
                <TableCell
                  id="tables_select-all-cell"
                  data-test-id="test-tables_select-all-cell"
                  aria-label="Select all rows"
                  sx={TablesStyles.tableHeaderCheckboxCells}
                >
                  <StyledCheckbox
                    id="tables_select-all-checkbox"
                    data-test-id="test-tables_select-all-checkbox"
                    aria-label="Select all rows checkbox"
                    checked={checkedItems.length === displayData.length}
                    onChange={handleSelectAllChange}
                    {...label}
                    color="default"
                  />
                </TableCell>
              )}

              {headers?.map((header: string, index: number) => (
                <TableCell
                  id={`tables_header-${header
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                  data-test-id={`test-tables_header-${header
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                  aria-label={`Column header ${header}`}
                  key={`${header}_${index}`}
                  sx={{
                    ...(type === "invoicesTable"
                      ? TablesStyles.invoicesTableHeaderCells
                      : TablesStyles.tableHeaderCells),
                  }}
                >
                  <Box sx={TablesStyles.tableHeader}>
                    <Typography
                      id={`tables_header-text-${header
                        .toLowerCase()
                        .replace(/\s+/g, "-")}`}
                      data-test-id={`test-tables_header-text-${header
                        .toLowerCase()
                        .replace(/\s+/g, "-")}`}
                      aria-label={`Header text ${header}`}
                      sx={TablesStyles.tableHeaderText}
                    >
                      {header}
                    </Typography>
                    {type === "invoicesTable" && (
                      <>
                        {sortOrder[index] ? (
                          <img
                            id={`tables_sort-icon-${index}`}
                            data-test-id={`test-tables_sort-icon-${index}`}
                            aria-label={`Sort ${header} column`}
                            onClick={() => handleSort(index)}
                            src={sortIcon}
                            alt={SORT_ICON}
                          />
                        ) : (
                          <img
                            id={`tables_sort-desc-icon-${index}`}
                            data-test-id={`test-tables_sort-desc-icon-${index}`}
                            aria-label={`Sort ${header} column in descending order`}
                            onClick={() => handleSort(index)}
                            src={descendingSort}
                            alt={SORT_ICON}
                          />
                        )}
                      </>
                    )}
                  </Box>
                </TableCell>
              ))}
              <TableCell
                id="tables_header-actions"
                data-test-id="test-tables_header-actions"
                aria-label="Actions column"
                sx={TablesStyles.tableHeaderLastCell}
              ></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayData?.map(
              (
                {
                  id,
                  providerId,
                  dueTime,
                  dueDate,
                  customerId,
                  carrier,
                  policyId,
                  lobCode,
                  system,
                  ...filteredRow
                },
                rowIndex
              ) => {
                const customerDetails = {
                  customerId,
                  customerName: filteredRow.customerName,
                };
                filteredRow =
                  type === "customerListing" ? filteredRow : { ...filteredRow };

                return (
                  <TableRow
                    id={`tables_row-${rowIndex}`}
                    data-test-id={`test-tables_row-${rowIndex}`}
                    aria-label={`Table row ${rowIndex + 1}`}
                    sx={{
                      ...TablesStyles.tableRow,
                      ...(type !== "nohover" && {
                        ":hover": {
                          backgroundColor: "var(--greyish-blue)",
                          ...(type === "policyListing" ||
                          type === "customerListing" ||
                          type === "myTasksTable"
                            ? { cursor: "pointer" }
                            : {}),
                        },
                      }),
                    }}
                    key={rowIndex}
                    onMouseEnter={
                      type !== "nohover" && type !== "policyListing"
                        ? () => setHoveredRow(rowIndex)
                        : undefined
                    }
                    onMouseLeave={
                      type !== "nohover" && type !== "policyListing"
                        ? () => setHoveredRow(null)
                        : undefined
                    }
                    onClick={() => {
                      handleRowClick(type, customerDetails, {
                        ...filteredRow,
                        id,
                        providerId,
                        dueTime,
                        dueDate,
                        customerId,
                        carrier,
                        policyId,
                        lobCode,
                        system,
                      });
                    }}
                  >
                    {primary && (
                      <TableCell
                        id={`tables_row-checkbox-${rowIndex}`}
                        data-test-id={`test-tables_row-checkbox-${rowIndex}`}
                        aria-label={`Select row ${rowIndex + 1}`}
                        sx={TablesStyles.tableBodyCheckboxCells}
                      >
                        <StyledCheckbox
                          id={`tables_checkbox-${rowIndex}`}
                          data-test-id={`test-tables_checkbox-${rowIndex}`}
                          aria-label={`Checkbox for row ${rowIndex + 1}`}
                          checked={checkedItems.includes(rowIndex)}
                          onChange={() => handleCheckboxChange(rowIndex)}
                          {...label}
                          color="default"
                        />
                      </TableCell>
                    )}
                    {Object.keys(filteredRow).map((key) => {
                      return (
                        <TableCell
                          id={`tables_cell-${key}-${rowIndex}`}
                          data-test-id={`test-tables_cell-${key}-${rowIndex}`}
                          aria-label={`${key} cell in row ${rowIndex + 1}`}
                          sx={{
                            ...(type === "invoicesTable"
                              ? TablesStyles.invoicesTableBodyCells
                              : TablesStyles.tableBodyCells),
                          }}
                          key={key}
                        >
                          {renderCellContent(key, filteredRow[key], rowIndex)}
                        </TableCell>
                      );
                    })}
                    <TableCell
                      id={`tables_row-actions-${rowIndex}`}
                      data-test-id={`test-tables_row-actions-${rowIndex}`}
                      aria-label={`Actions for row ${rowIndex + 1}`}
                      sx={{
                        ...TablesStyles.tableBodyLastCell,
                        ...(type === "documentListingList" && {
                          textAlign: "right",
                        }),
                      }}
                    >
                      {/* {type === "overviewTable" && (
                        <Box
                          sx={{
                            ...(hoveredRow === rowIndex
                              ? TablesStyles.imagePresent
                              : TablesStyles.imageAbsent),
                            ...TablesStyles.overView,
                          }}
                        >
                          <ImageAndText image={paynowIcon} text={PAY_NOW} />
                          <IconButton
                            sx={
                              hoveredRow === rowIndex
                                ? TablesStyles.imagePresent
                                : TablesStyles.imageAbsent
                            }
                            onClick={() => {
                              setToolTipIndex(rowIndex);
                              handleToolTip(rowIndex);
                            }}
                          >
                            <CustomTooltip
                              menuIcon={menuIcon}
                              MENU_ICON={MENU_ICON}
                              myTasksTooltip={customerDetailsOverviewOptions}
                              handleTooltipItem={handleToolTipItem}
                              open={
                                openTooltipRow === rowIndex &&
                                toolTipIndex === rowIndex
                              }
                              handleTooltip={() => handleToolTip(toolTipIndex)}
                            />
                          </IconButton>
                        </Box>
                      )} */}
                      {type === "invoicesTable" && (
                        <Box
                          id={`tables_invoice-actions-${rowIndex}`}
                          data-test-id={`test-tables_invoice-actions-${rowIndex}`}
                          aria-label={`Invoice actions for row ${rowIndex + 1}`}
                          sx={{
                            ...(hoveredRow === rowIndex
                              ? TablesStyles.imagePresent
                              : TablesStyles.imageAbsent),
                            ...TablesStyles.overView,
                          }}
                        >
                          <ImageAndText image={downloadIcon} text={DOWNLOAD} />
                          <ImageAndText image={paynowIcon} text={PAY_NOW} />
                        </Box>
                      )}
                      {/* {type === "customerListing" && (
                        <Box
                          sx={{
                            ...(hoveredRow === rowIndex
                              ? TablesStyles.imagePresent
                              : TablesStyles.imageAbsent),
                            ...TablesStyles.customerListingHoverElement,
                          }}
                        >
                          <ImageAndText 
                            onhandleClick={() =>
                              navigate("/agent/customerDetails")
                            }
                            image={docIcon}
                            text={DETAILS}
                          />
                        </Box>
                      )} */}

                      {type === "commissionStatements" && (
                        <Box
                          id={`tables_commission-actions-${rowIndex}`}
                          data-test-id={`test-tables_commission-actions-${rowIndex}`}
                          aria-label={`Commission statement actions for row ${
                            rowIndex + 1
                          }`}
                          sx={{
                            ...(hoveredRow === rowIndex
                              ? TablesStyles.imagePresent
                              : TablesStyles.imageAbsent),
                            ...TablesStyles.commionStatementsHoverElement,
                          }}
                        >
                          <ImageAndText
                            imageClassName={TablesStyles.docIcon}
                            additionalClassName={
                              TablesStyles.commissionStatementsHoverContainer
                            }
                            image={docIcon}
                            text={DETAILS}
                            onClick={() => navigate("/agent/monthlyStatement")}
                          />
                          <ImageAndText
                            imageClassName={TablesStyles.downloadIcon}
                            additionalClassName={
                              TablesStyles.commissionStatementsHoverContainer
                            }
                            image={downloadIcon}
                            text={DOWNLOAD}
                          />
                        </Box>
                      )}
                      {type === "documentListingList" && (
                        <IconButton
                          id={`tables_document-menu-${rowIndex}`}
                          data-test-id={`test-tables_document-menu-${rowIndex}`}
                          aria-label={`Document menu for row ${rowIndex + 1}`}
                          sx={
                            hoveredRow === rowIndex
                              ? TablesStyles.imagePresent
                              : TablesStyles.imageAbsent
                          }
                          onClick={() => {
                            setToolTipIndex(rowIndex);
                            handleToolTip(rowIndex);
                          }}
                        >
                          <CustomTooltip
                            menuIcon={menuIcon}
                            MENU_ICON={MENU_ICON}
                            myTasksTooltip={drawerOptions}
                            handleTooltipItem={handleToolTipItem}
                            open={
                              openTooltipRow === rowIndex &&
                              toolTipIndex === rowIndex
                            }
                            handleTooltip={() => handleToolTip(toolTipIndex)}
                          />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                );
              }
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Drawers open={notesOpen} toggleDrawer={handleNotesClick} heading={NOTES}>
        <Notes personDataArray={personData} personChatArray={personChat} />
      </Drawers>
      <ModalComponent
        headingAdditionalClass={TablesStyles.modalHeading}
        heading={
          isFolder
            ? ARE_YOU_SURE_ARCHIVE + `"${fileName}"` + FOLDER_LOWER
            : ARCHIVE_FILE
        }
        open={modalOpen}
        handleOpen={handleModalClose}
        additionalClassContainer={TablesStyles.modalContainer}
        headingContainerAdditionalClass={TablesStyles.modalHeadingContainer}
      >
        <Box
          id="tables_archive-content"
          data-test-id="test-tables_archive-content"
          aria-label="Archive confirmation content"
          sx={TablesStyles.contentContainer}
        >
          <ImageAndText
            image={<CustomIcon iconName="Archive" />}
            text={
              isFolder
                ? ARCHIVING_THE_FOLDER
                : ARE_YOU_SURE_ARCHIVE + `"${fileName}"` + FILE_LOWER
            }
            additionalClassText={TablesStyles.imageText}
          />
          <Box
            id="tables_archive-buttons"
            data-test-id="test-tables_archive-buttons"
            aria-label="Archive action buttons"
            sx={TablesStyles.buttonsContainer}
          >
            <CustomButton
              text={"Confirm"}
              additionalClassName={TablesStyles.cancelButton}
            />
            <CustomButton
              onHandleClick={handleModalClose}
              text={CANCEL}
              type="outlined"
              additionalClassName={TablesStyles.cancelButton}
            />
          </Box>
        </Box>
      </ModalComponent>
      <Drawers
        open={drawerOpen}
        toggleDrawer={toggleDrawer}
        heading={"Send Reminder"}
      >
        <SendRemainder
          recieverName={sendRemaindersAndShareMarketData.recieverName}
          dropDownData={sendRemaindersAndShareMarketData.dropdownData}
          fileUploadName={sendRemaindersAndShareMarketData.fileUploadName}
          fileUploadSize={sendRemaindersAndShareMarketData.fileUploadSize}
          handleRemainderChange={handleRemainderChange}
          selectedDropdownValue={selectedDropdownValue}
          onCancelClick={toggleDrawer}
        />
      </Drawers>
      {/* <AddTaskForm
        open={isFormOpen || isEditTask!}
        handleClose={closeDrawer}
        isUpdate={true}
        taskData={toolTipRowData}
        taskName={TaskName}
      /> */}
    </>
  );
};

export default Tables;
